import React from 'react';
import { CheckCircle, Clock, WarningCircle } from '@phosphor-icons/react';
import { dueLabel } from './taxModel';

function Status({ period }) {
  if (period.status === 'presented') {
    return <span className="inline-flex items-center gap-1 text-xs text-emerald-400"><CheckCircle size={14} weight="fill" /> Presentado</span>;
  }
  if (period.overdue) {
    return <span className="inline-flex items-center gap-1 text-xs font-semibold text-red-400"><WarningCircle size={14} weight="fill" /> {dueLabel(period)}</span>;
  }
  const urgent = period.period_ended && period.days_to_due <= 7;
  return <span className={`inline-flex items-center gap-1 text-xs ${urgent ? 'text-amber-400' : 'text-[#9CA3AF]'}`}><Clock size={14} /> {dueLabel(period)}</span>;
}

export function PeriodList({ periods, selected, onSelect }) {
  return (
    <ul className="flex gap-2 overflow-x-auto pb-2 lg:block lg:space-y-2 lg:overflow-visible lg:pb-0" aria-label="Períodos">
      {periods.map((period) => {
        const active = period.period === selected;
        return (
          <li key={period.period} className="min-w-[12rem] shrink-0 lg:min-w-0">
            <button
              type="button"
              onClick={() => onSelect(period.period)}
              aria-current={active ? 'true' : undefined}
              className={`w-full rounded-lg border px-3 py-2.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E2B05E] ${
                active ? 'border-[#E2B05E] bg-[#E2B05E]/10' : 'border-[#242E42] bg-[#151B26] hover:border-[#3A4560]'
              } ${period.overdue ? 'border-l-4 border-l-red-500' : ''}`}
            >
              <span className="block text-sm font-medium text-[#F3F4F6]">{period.label}</span>
              <span className="block text-xs text-[#6B7280]">Período {period.period}</span>
              <span className="mt-1 block"><Status period={period} /></span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
